import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=51f19118&"
import script from "./UploadDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports